import { render, staticRenderFns } from "./youLovePartner.vue?vue&type=template&id=320d63c0&scoped=true"
import script from "./youLovePartner.vue?vue&type=script&lang=js"
export * from "./youLovePartner.vue?vue&type=script&lang=js"
import style0 from "./youLovePartner.vue?vue&type=style&index=0&id=320d63c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d63c0",
  null
  
)

export default component.exports